<script>
import { BaseStoryCardElementMixin } from "%/dynamic-component-editor/standard-components/base-story-card/base-story-card-element-mixin";
import StoryCardClickBehavior from "%/dynamic-component-editor/options/story-card-click-behavior";
import HideStoryMedia from "%/dynamic-component-editor/options/hide-story-media";
import UrlElement from "%/dynamic-component-editor/standard-elements/url-element/UrlElement.vue";

export default {
  name: "StoryContent",
  elementPanelSettings: {
    displayName: "Story Text Preview",
    displayIcon: "paragraph",
    elementType: "element",
    elementGroup: "storyElements",
  },
  extends: UrlElement,
  mixins: [BaseStoryCardElementMixin],
  options: [
    StoryCardClickBehavior,
    HideStoryMedia,
  ],
  computed: {
    label() {
      return this.entity.text;
    },
    computedHref() {
      return this.storyHref;
    },
  },
};
</script>

